import React from "react";
import { EmployeeStory } from "interfaces/api/apiInterfaces";
import { Featured } from "./Featured";
import { Hero } from "./Hero";
import { Standard } from "./Standard";

export type EmployeeCardProps = {
    employee: EmployeeStory;
    layout?: "featured-left" | "featured-right" | "hero" | "standard";
    img?: string;
    onClick?: () => void;
} & React.HTMLProps<HTMLElement>;

export const EmployeeCard = (props: EmployeeCardProps) => {
    switch (props.layout) {
    case "featured-left":
    case "featured-right":
        return <Featured {...props} />;
    case "hero":
        return <Hero {...props} />;
    default:
        return <Standard {...props} />;
    }
};
